import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const loginCallBackRoute = () => [
  {
    path: '/pdp-auth/login-callback',
    component: () => import('@/views/LoginCallbackPage/LoginCallbackPage.vue'),
    name: 'loginCallback-en',
    meta: {
      locale: HgSupportedLanguage.EN,
      getLanguageSwitchLink(route: any) {
        return {
          name: 'loginCallback-en',
          query: route.query,
          params: route.params,
        };
      },
    },
  },
];
